// extracted by mini-css-extract-plugin
export var button = "_cy-0";
export var icon = "_cy-1";